/**
 * Section containing Visitax QR code information.
 */
import { Box, Typography } from "@mui/material";
import QRVisitax from "../../../../assets/images/HomePage/VisitaxQR.png";

type QRContentProps = {
  paymentMode?: boolean;
};

const QRContent = ({ paymentMode = false }: QRContentProps) => (
  <Box
    sx={{
      ...(paymentMode
        ? {
            alignItems: "center",
            bgcolor: "#F6F6F6",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            minHeight: "100%",
            position: "relative",
            width: "100%",
            maxWidth: "100%",
            zIndex: 1,
          }
        : {
            position: "fixed",
            top: 0,
            padding: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }),
    }}
  >
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        maxWidth: "572px",
        px: 2,
        textAlign: "center",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          color: "#000000",
          fontFamily: "Candara",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "20px",
          maxWidth: "560px",
        }}
      >
        <Box component="span" sx={{ fontWeight: 700 }}>
          Article 51 -{" "}
        </Box>
        Octies of the Quintana Roo State Rights Law indicates the contributions to be paid by
        foreign tourists entering the State, during their stay or upon departure.
      </Typography>

      <Typography
        sx={{
          color: "#000000",
          fontFamily: "Candara",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "20px",
          maxWidth: "560px",
        }}
      >
        Once the payment is made, you are going to get a digital QR code.
      </Typography>

      <Typography
        sx={{
          color: "#761542",
          fontFamily: "Candara",
          fontSize: "28px",
          fontWeight: 700,
          lineHeight: "20px",
          mt: 1,
        }}
      >
        Where to pay?
      </Typography>

      <Box
        component="img"
        src={QRVisitax}
        alt="Visitax QR"
        sx={{
          height: "272px",
          maxWidth: "100%",
          objectFit: "contain",
          width: "279px",
        }}
      />

      <Typography
        sx={{
          color: "#761542",
          fontFamily: "Candara",
          fontSize: "38px",
          fontWeight: 700,
          lineHeight: "20px",
          mt: 1,
        }}
      >
        Plase pay here
      </Typography>

      <Typography
        sx={{
          color: "#00596A",
          fontFamily: "Candara",
          fontSize: "12px",
          fontWeight: 700,
          lineHeight: "11px",
        }}
      >
        For more information, please visit our website
        <br />
        www.visitaxonline.com
      </Typography>
    </Box>
  </Box>
);

export default QRContent;
